import { Directive, OnDestroy } from '@angular/core';
import { EventDispatcher } from '../../../nx-data/src/lib/events/nx-events';

@Directive()
export class NgxEventListener implements OnDestroy {
  constructor(private readonly eventDispatcher: EventDispatcher<any>) {
    eventDispatcher.registerEventListener(this as any);
  }

  ngOnDestroy(): void {
    this.eventDispatcher.removeEventListener(this as any);
  }
}
